export default __webpack_public_path__ + "static/media/tmvc-pkg-icon.d97c87e9.svg";